import { useState } from 'react'
import axios from 'axios'
import {
  Container,
  Row,
  Col,
  Card,
  Form,
  Button,
  Alert,
  Spinner,
} from 'react-bootstrap'
import { useNavigate } from 'react-router-dom'
import Swal from 'sweetalert2'
import Signup from '../Assets/screens/SignupVector.png'
import AiLogo1 from '../Assets/Assests/Logos/Tesla bird logo.png'
import Logo1 from '../Assets/Assests/Logos/Tesla bird logo.png'

const PaymentForm = () => {
  const navigate = useNavigate()
  const [formData, setFormData] = useState({
    name: '',
    mobile_number: '',
    email_id: '',
    residential_address: '',
    reference: '',
    quantity: 1,
  })

  const [error, setError] = useState({})
  const [loading, setLoading] = useState(false)
  const [verifying, setVerifying] = useState(false)
  const UNIT_PRICE = 2499

  const validateField = (name, value) => {
    let errors = { ...error }

    if (!value.trim()) {
      errors[name] = `${name.replace('_', ' ')} is required`
    } else {
      switch (name) {
        case 'name':
          if (!/^[A-Za-z\s]{3,}$/.test(value)) {
            errors[name] =
              'Name must contain only letters and be at least 3 characters long'
          } else {
            delete errors[name]
          }
          break

        case 'email_id':
          if (!/^[\w-]+(\.[\w-]+)*@([\w-]+\.)+[a-zA-Z]{2,7}$/.test(value)) {
            errors[name] = 'Enter a valid email address'
          } else {
            delete errors[name]
          }
          break

        case 'mobile_number':
          const phoneRegex = /^\+(?:[0-9] ?){6,14}[0-9]$/
          if (!phoneRegex.test(value)) {
            errors[name] =
              'Enter a valid mobile number with country code (e.g., +91 9876543210)'
          } else {
            delete errors[name]
          }
          break

        case 'residential_address':
          if (value.trim().length < 10) {
            errors[name] = 'Address must be at least 10 characters long'
          } else {
            delete errors[name]
          }
          break
        case 'reference':
          if (value && !/^[A-Za-z\s]{3,}$/.test(value)) {
            errors[name] =
              'Reference must contain only letters and be at least 3 characters long'
          } else {
            delete errors[name]
          }
          break

        // case 'reference':
        //   if (!/^[A-Za-z\s]{3,}$/.test(value)) {
        //     errors[name] =
        //       'Referral Name must contain only letters and be at least 3 characters long'
        //   } else {
        //     delete errors[name]
        //   }
        //   break

        default:
          delete errors[name]
          break
      }
    }
    setError(errors)
  }

  // const handleChange = (e) => {
  //   const { name, value } = e.target
  //   setFormData((prev) => ({
  //     ...prev,
  //     [name]: name === 'quantity' ? Math.max(1, Number(value)) : value,
  //   }))
  //   validateField(name, value)
  // }

  const handleChange = (e) => {
    const { name, value } = e.target

    setFormData((prev) => ({
      ...prev,
      [name]:
        name === 'quantity'
          ? value === ''
            ? ''
            : Math.max(1, Number(value))
          : value,
    }))

    validateField(name, value)
  }

  const loadRazorpayScript = () => {
    return new Promise((resolve) => {
      const script = document.createElement('script')
      script.src = 'https://checkout.razorpay.com/v1/checkout.js'
      script.onload = () => resolve(true)
      script.onerror = () => resolve(false)
      document.body.appendChild(script)
    })
  }

  const handleSubmit = async (e) => {
    e.preventDefault()

    const newErrors = {}
    Object.keys(formData).forEach((key) => {
      if (!formData[key] && key !== 'message' && key !== 'reference') {
        newErrors[key] = `${key.replace('_', ' ')} is required`
      }
    })

    if (Object.keys(newErrors).length > 0) {
      setError(newErrors)
      return
    }

    setLoading(true)

    try {
      const payload = {
        name: formData.name,
        phone_number: formData.mobile_number,
        email: formData.email_id,
        address: formData.residential_address,
        quantity: formData.quantity,
        reference_email: formData.reference,
      }

      const orderRes = await axios.post(
        'https://aimuseumbackend.teslabird.com/auth/make-paymentkit-order/',
        payload
      )

      const scriptLoaded = await loadRazorpayScript()
      if (!scriptLoaded) {
        Swal.fire(
          'Failed',
          'Razorpay SDK failed to load. Are you online?',
          'error'
        )
        setLoading(false)
        return
      }

      const { amount, order_id, currency } = orderRes.data

      const options = {
        // key: 'rzp_test_XF9v6oecgVPv6f',
        key: 'rzp_live_C6kUQM5U7CPGxp',
        amount: amount.toString(),
        currency,
        name: 'Tesla Bird',
        description: 'Kit Purchase',
        order_id,
        handler: async function (response) {
          try {
            setVerifying(true)
            const verifyRes = await axios.put(
              'https://aimuseumbackend.teslabird.com/auth/verify-kitpayment/',
              {
                order_id: response.razorpay_order_id,
                razorpay_payment_id: response.razorpay_payment_id,
                razorpay_signature: response.razorpay_signature,
              }
            )

            if (verifyRes.status === 200) {
              Swal.fire({
                icon: 'success',
                title: 'Payment Successful',
                text: 'Credentials have been shared to your email id.',
                confirmButtonColor: '#002740',
              })
              navigate('/sign-in')
            }
          } catch (verifyErr) {
            Swal.fire('Error', 'Payment verification failed', 'error')
          }
        },
        prefill: {
          name: formData.name,
          email: formData.email_id,
          contact: formData.mobile_number,
        },
        theme: {
          color: '#002740',
        },
      }

      const razorpay = new window.Razorpay(options)
      razorpay.open()
    } catch (err) {
      Swal.fire({
        icon: 'error',
        title: 'Submission Failed',
        text: 'Unable to initiate payment. Please try again later.',
        confirmButtonText: 'Retry',
        confirmButtonColor: '#002740',
      })
    } finally {
      setLoading(false)
    }
  }

  return (
    <>
      {verifying && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            zIndex: 9999,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Spinner animation='border' variant='light' />
          <span className='text-light ms-2'>Verifying Payment...</span>
        </div>
      )}
      <Container fluid className='min-vh-100 d-flex'>
        <Row className='w-100'>
          {/* Left Side Illustration */}
          <Col
            md={6}
            className='d-none d-md-flex flex-column align-items-center justify-content-center text-white'
            style={{ backgroundColor: '#DDEEFC' }}
          >
            <div
              className='d-flex align-items-center'
              style={{ position: 'absolute', top: '0', left: '0' }}
            >
              <a href='/'>
                <img
                  src={AiLogo1}
                  alt='Museum Logo'
                  width={80}
                  height={80}
                  style={{
                    marginRight: '20px',
                    marginLeft: '20px',
                    marginTop: '15px',
                  }}
                />
              </a>
            </div>
            <img
              src={Signup}
              alt='Illustration'
              className='img-fluid'
              style={{ maxWidth: '350px', marginTop: '100px' }}
            />
          </Col>

          {/* Form Side */}
          {/* <Col
          xs={12}
          md={6}
          className='d-flex flex-column align-items-center justify-content-center p-4'
        > */}
          <Col
            xs={12}
            md={6}
            className='d-flex flex-column align-items-center justify-content-center p-4'
            style={{ minHeight: '100vh' }}
          >
            <a href='/'>
              <img
                src={Logo1}
                alt='Logo'
                className='img-fluid d-block d-md-none mb-3'
                style={{ width: '120px' }}
              />
            </a>

            <Card
              className='shadow-lg rounded-4 w-100'
              style={{
                maxWidth: '400px',
                maxHeight: '90vh', // slightly less than 100vh to prevent hard edge fit
                display: 'flex',
                flexDirection: 'column',
              }}
            >
              <Card.Body
                style={{
                  overflowY: 'auto',
                  padding: '1.5rem',
                }}
              >
                <h2 className='fw-bold mb-3'>Payment Details Form</h2>

                {Object.keys(error).length > 0 && (
                  <Alert variant='danger'>
                    {Object.values(error).map((err, idx) => (
                      <div key={idx}>{err}</div>
                    ))}
                  </Alert>
                )}

                <Form onSubmit={handleSubmit}>
                  {[
                    { label: 'Full Name', name: 'name', type: 'text' },
                    {
                      label: 'Contact No.',
                      name: 'mobile_number',
                      type: 'text',
                    },
                    { label: 'Email', name: 'email_id', type: 'email' },
                  ].map((field, idx) => (
                    <Form.Group className='mb-2' key={idx}>
                      <Form.Label className='text-muted small'>
                        {field.label}
                      </Form.Label>
                      <Form.Control
                        type={field.type}
                        name={field.name}
                        placeholder={`Enter ${field.label.toLowerCase()}`}
                        value={formData[field.name]}
                        onChange={handleChange}
                        className='border-0 border-bottom'
                        style={{ color: 'black' }}
                        isInvalid={!!error[field.name]}
                      />
                      <Form.Control.Feedback type='invalid'>
                        {error[field.name]}
                      </Form.Control.Feedback>
                    </Form.Group>
                  ))}

                  <Form.Group className='mb-2'>
                    <Form.Label className='text-muted small'>
                      Residential Address
                    </Form.Label>
                    <Form.Control
                      as='textarea'
                      name='residential_address'
                      placeholder='Enter your full residential address'
                      value={formData.residential_address}
                      onChange={handleChange}
                      className='border-0 border-bottom'
                      rows={2}
                      style={{ color: 'black' }}
                      isInvalid={!!error.residential_address}
                    />
                    <Form.Control.Feedback type='invalid'>
                      {error.residential_address}
                    </Form.Control.Feedback>
                  </Form.Group>

                  <Form.Group className='mb-2'>
                    <Form.Label className='text-muted small'>
                      Quantity
                    </Form.Label>
                    <Form.Control
                      type='number'
                      name='quantity'
                      min='1'
                      value={formData.quantity}
                      onChange={handleChange}
                      className='border-0 border-bottom'
                      style={{ color: 'black' }}
                    />
                  </Form.Group>
                  <div className='mb-3 text-end fw-bold text-muted'>
                    Total: ₹{formData.quantity * UNIT_PRICE}
                  </div>

                  <Form.Group className='mb-2'>
                    <Form.Label className='text-muted small'>
                      Reference
                    </Form.Label>
                    <Form.Control
                      type='text'
                      name='reference'
                      placeholder='Enter your reference'
                      value={formData.reference}
                      onChange={handleChange}
                      className='border-0 border-bottom'
                      style={{ color: 'black' }}
                      isInvalid={!!error.reference}
                    />
                    <Form.Control.Feedback type='invalid'>
                      {error.reference}
                    </Form.Control.Feedback>
                  </Form.Group>

                  <Button
                    type='submit'
                    className='w-100 text-white rounded-pill'
                    style={{ backgroundColor: '#002740' }}
                    disabled={loading}
                  >
                    {loading ? (
                      <Spinner animation='border' size='sm' />
                    ) : (
                      'Pay Now'
                    )}
                  </Button>
                </Form>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  )
}

export default PaymentForm
